<nb-card size="medium" class="dialog-wizard">
  <nb-card-header>
    <div class="flex justify-between items-center">
      <span>Step {{ stepIndex + 1 }} of {{ totalSteps }}</span>
      <button style="float:right" class="nrk-button" (click)="cancel()">✕</button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <ng-content></ng-content>
    <ng-container *ngIf="steps?.length > 0">
      <ng-container
        *ngTemplateOutlet="steps.toArray()[stepIndex].template; context: { data: data }"
      ></ng-container>
    </ng-container>

    <ng-container *ngIf="!steps?.length">
      <p class="text-gray-500 text-center">No steps found.</p>
    </ng-container>
  </nb-card-body>

  <nb-card-footer class="footer-actions">
    <button class="btn btn-sm btn-danger" (click)="cancel()">Cancel</button>
    <button class="btn btn-sm btn-info" *ngIf="stepIndex > 0" (click)="prev()">← Back</button>
    <button class="btn btn-sm btn-info" *ngIf="stepIndex < totalSteps - 1" (click)="next()">Next →</button>
    <button class="btn btn-sm btn-success" *ngIf="stepIndex === totalSteps - 1" (click)="finish()">Finish ✓</button>
  </nb-card-footer>
</nb-card>
